<template>
	<el-drawer size="50%" title="部署配置" :visible.sync="dialogVisible" :modal-append-to-body="false" direction="rtl" :wrapperClosable="false"
		class="customer-drawer-common website-dispose">
		<section>
			<h1>部署网页组件（推荐）</h1>
			<mark>网页咨询组件同时支持桌面网站和移动网站，提供强大的客户行为采集能力和系统对接能力。</mark>
			<el-row :gutter="10" class="website-dispose__row">
				<el-col :span="4"><span>特性包含：</span></el-col>
				<el-col :span="20">
					<ul>
						<li>自动识别访客，通过API对接登录客户身份并获取资料</li>
						<li>自动采集客户访问轨迹，通过API传入自定义访问行为</li>
						<li>通过JS-API根据客服场景灵活调整客服设置</li>
					</ul>
				</el-col>
			</el-row>
			<el-row :gutter="10" class="website-dispose__row">
				<el-col :span="4"><span>组件代码：</span></el-col>
				<el-col :span="18">
					<p>通过复制以下代码，嵌入到您网站的</body>标签之前，将<span>复制的代码中带有“****”替换为您的自定义域名</span>（test为非法域名不可用），完成以上操作后部署完成。</p>
				</el-col>
			</el-row>
			<el-row :gutter="10" class="website-dispose__row">
				<el-col :span="4">
					<el-button type="primary" icon="el-icon-document-copy" plain size="mini">复制代码</el-button>
				</el-col>
				<el-col :span="18">
					<div class="code-area">
						这里是代码信息请复制后替换这里是代码信息请复制后替换这里是代码信息请复制后替换这里是代码信息请复制后替换这里是代码信息请复制后替换。
					</div>
				</el-col>
			</el-row>
		</section>
		<section>
			<h1>部署聊天链接</h1>
			<el-row :gutter="10" class="website-dispose__row">
				<el-col :span="4"><span>聊天链接：</span></el-col>
				<el-col :span="18">
					<p>通过复制以下链接到您的网站中，将复制的代码中带有“****”替换为您的自定义域名（test为非法域名不可用），完成以上操作后部署完成。</p>
				</el-col>
			</el-row>
			<el-row :gutter="10" class="website-dispose__row">
				<el-col :span="4">
					<el-button type="primary" icon="el-icon-document-copy" plain size="mini">复制代码</el-button>
				</el-col>
				<el-col :span="18">
					<div class="code-area">
						这里是代码信息请复制后替换这里是代码信息请复制后替换这里是代码信息请复制后替换这里是代码信息请复制后替换这里是代码信息请复制后替换。
					</div>
				</el-col>
			</el-row>
		</section>
		<section>
			<h1>授权技能组</h1>
			<el-form ref="form" :model="form" :rules="formRules" label-width="90px">
				<el-row :gutter="30">
					<el-col :span="12">
						<el-form-item label="品牌名称：" prop="brand">
							<el-select v-model="form.brand" clearable placeholder="请选择">
								<el-option v-for="item in brand_options" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="技能组：" prop="skillGroup">
							<el-select v-model="form.skillGroup" clearable placeholder="请选择">
								<el-option v-for="item in skillGroup_options" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</section>
		<div class="footer">
			<el-button @click="dialogVisible = false" size="mini">取 消</el-button>
			<el-button type="primary" size="mini" @click="onSave" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}
			</el-button>
		</div>
	</el-drawer>
</template>

<script>
	export default {
		data() {
			return {
				dialogVisible: false,
				loading:false,
				brand_options:[],
				skillGroup_options:[],
				form:{
					brand:'',
					skillGroup:''
				},
				formRules:{
					brand:[{ required: true, message: '请选择品牌', trigger: 'change' }],
					skillGroup:[{ required: true, message: '请选择技能组', trigger: 'change' }]
				}
			}
		},
		methods:{
			onSave(){},
			openDispose(){
				this.dialogVisible = true
			}
		}
	}
</script>

<style lang="scss" scoped>
	.website-dispose {
		font-size: 14px;

		section {
			padding: 0 40px;

			&:nth-of-type(n+2) {
				margin-top: 30px;
			}
		}

		h1 {
			color: #3C4353;
			margin-bottom: 16px;
			font-size: 14px;
		}

		mark {
			padding: 2px 12px;
			background-color: #FDF4E8;
			color: #F29522;
		}

		&__row {
			margin: 15px 0;

			ul {
				li {
					list-style: none;
					color: #566980;
					line-height: 26px;
				}
			}

			p {
				line-height: 26px;
				color: #566980;

				span {
					color: #FF504D;
				}
			}

			.code-area {
				padding: 6px 10px;
				background: #F9F9F9;
				border-radius: 4px;
				border: 1px solid #D8D8D8;
				color: #3C4353;
				font-size: 12px;
				line-height: 24px;
			}

		}
	}
</style>
